module.exports = __webpack_public_path__ + "static/img/警告.5c4ea9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/警告.png
// module id = K5YR
// module chunks = 16